import React from 'react';
import { Formik, FormikHelpers } from 'formik';
import { FormHelperText } from '@material-ui/core';

import { AddLeadPartnerSchema } from '@project/validators';
import { BaseFormProps, ErrorObject, AddLeadPartnerProps } from '@project/types';
import { Button, FormTextField } from '@project/components';

export const AddLeadPartnerForm: React.FC<BaseFormProps<AddLeadPartnerProps>> = ({
  initialValues,
  submitForm,
  onSuccess,
}) => {
  const _handleFormSubmitError = (
    error: ErrorObject,
    actions: FormikHelpers<AddLeadPartnerProps>,
  ) => {
    actions.setSubmitting(false);
    actions.setStatus(error.detail);
  };

  const _handleSubmission = (
    formData: AddLeadPartnerProps,
    actions: FormikHelpers<AddLeadPartnerProps>,
  ) => {
    submitForm(formData)
      .then(() => {
        onSuccess();
      })
      .catch((error: ErrorObject) => {
        _handleFormSubmitError(error, actions);
      })
      .finally(() => actions.setSubmitting(false));
  };

  return (
    <Formik
      initialValues={initialValues}
      validateOnBlur
      validateOnChange={false}
      onSubmit={_handleSubmission}
      validationSchema={AddLeadPartnerSchema}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        isSubmitting,
        values,
        touched,
        errors,
        handleReset,
        status,
      }) => {
        return (
          <form
            onReset={handleReset}
            onSubmit={handleSubmit}
            className="flex flex-auto flex-col gap-4 py-1 mx-7 w-80"
          >
            <p className="flex justify-center auth-heading text-center">Add Lead Partner</p>

            <FormTextField
              variableName="name"
              placeholder="Name"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              className="w-full"
            />

            <FormTextField
              variableName="email"
              placeholder="Email"
              type="email"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              className="w-full"
            />

            <FormTextField
              variableName="utmSource"
              placeholder="UTM Source"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              className="w-full"
            />

            <FormTextField
              variableName="viableDaysCount"
              placeholder="Viable Days Count"
              type="number"
              values={values}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched}
              errors={errors}
              className="w-full"
            />

            {status && (
              <FormHelperText error className="text-center">
                {status}
              </FormHelperText>
            )}

            <Button
              isLoading={isSubmitting}
              onClick={handleSubmit}
              className="w-4/5 bg-secondary hover:bg-secondary-dark text-white text-base self-center my-7"
            >
              Add Lead Partner
            </Button>
          </form>
        );
      }}
    </Formik>
  );
};
